<section
  #cardEl
  class="card"
  [class.is-phone]="isPhone()"
  aria-labelledby="quick-tour-card-title"
>
  <div
    #contentEl
    class="content"
  >
    <header class="head">
      <h2
        id="quick-tour-card-title"
        class="title"
      >
        {{ T.ONBOARDING.WANT_MORE.TITLE | translate }}
      </h2>
      <span class="counter">
        {{
          T.ONBOARDING.TOUR.COUNTER
            | translate
              : { nr: quickTourService.stepNr(), total: quickTourService.stepCount() }
        }}
      </span>
      <button
        type="button"
        class="close-btn"
        [attr.aria-label]="T.ONBOARDING.HINTS.SKIP_ARIA | translate"
        (click)="quickTourService.end()"
      >
        <span aria-hidden="true">✕</span>
      </button>
    </header>

    <p class="intro">{{ T.ONBOARDING.WANT_MORE.INTRO | translate }}</p>
    <ul class="teasers">
      @for (teaser of TEASERS; track teaser.text) {
        <li>
          <mat-icon aria-hidden="true">{{ teaser.icon }}</mat-icon>
          <span [innerHTML]="teaser.text | translate"></span>
        </li>
      }
    </ul>

    @if (isSyncLineShown()) {
      <p class="aside">
        <mat-icon aria-hidden="true">cloud_off</mat-icon>
        <span>{{ T.ONBOARDING.WANT_MORE.SYNC | translate }}</span>
      </p>
    }
    @if (isSearchShown()) {
      <p class="aside">
        <mat-icon aria-hidden="true">search</mat-icon>
        @if (isPhone()) {
          <span>{{ T.ONBOARDING.WANT_MORE.SEARCH_PHONE | translate }}</span>
        } @else {
          <span
            [innerHTML]="T.ONBOARDING.WANT_MORE.SEARCH | translate: { key: searchKey() }"
          ></span>
        }
      </p>
    }
    @if (isShortSyntaxShown()) {
      <p class="aside">
        <mat-icon aria-hidden="true">keyboard</mat-icon>
        <span [innerHTML]="T.ONBOARDING.WANT_MORE.SHORT_SYNTAX | translate"></span>
      </p>
    }

    <div class="actions">
      <button
        type="button"
        class="card-action"
        (click)="quickTourService.openSettings()"
      >
        {{ T.ONBOARDING.WANT_MORE.OPEN_SETTINGS | translate }}
      </button>
      <button
        type="button"
        class="card-action"
        (click)="quickTourService.end()"
      >
        {{ T.ONBOARDING.WANT_MORE.DONE | translate }}
      </button>
    </div>
    <p class="foot">{{ T.ONBOARDING.WANT_MORE.FOOTER | translate }}</p>
  </div>
</section>
